import { render, staticRenderFns } from "./EmpresaRoute.vue?vue&type=template&id=08ace10a"
import script from "./EmpresaRoute.vue?vue&type=script&lang=js"
export * from "./EmpresaRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports